import { isMobile } from "react-device-detect"
import { isStandalone } from "~/shared/lib/utils"

export const isMobileOrStandalone = isMobile || isStandalone()

export const fontSize = isMobileOrStandalone ? 14 : 12

const calcSizeInRem = (px : number) => `${Math.trunc(px / 16)}rem`

export const breakPoints = {
	xxs: calcSizeInRem(400),
	xs: calcSizeInRem(600),
	sm: calcSizeInRem(768),
	md: calcSizeInRem(992),
	lg: calcSizeInRem(1200),
}